import { Component } from '@angular/core';

@Component({
    selector: 'collaboration-section',
    standalone: true,
    templateUrl: './collaboration-section.component.html',
    styleUrl: './collaboration-section.component.less',
})
export class CollaborationComponent {}
